module.exports = __webpack_public_path__ + "img/deviceicon23.2acea13b.png";